<template>
<b-container style="max-width: 1200px !important">
<b-row>
<b-col cols="12">
    <b-row class="mt-2">
    <vue-markdown :show="activePlugin === 'noDRM'" style="overflow: auto;" class="col-xl-7 col-12" :style="(activePlugin === 'withDRM')?'display: none' : ''" @rendered="onrender">
Example of index.html using Video.js and integrating **QUANTEEC** without DRM.
``` html
&lt;head>
    &lt;link href="https://vjs.zencdn.net/7.18.1/video-js.css" rel="stylesheet" />

    &lt;script src="https://vjs.zencdn.net/7.18.1/video.min.js">&lt;/script>
    &lt;script src="https://files.quanteec.com/quanteec/latest/quanteec-vhs.min.js">&lt;/script> &lt;!-- 1-include QUANTEEC script-->
&lt;/head>
&lt;body>
    &lt;video id="videoplayer" class="video-js vjs-default-skin" controls>&lt;/video>

    &lt;script>
        document.addEventListener("DOMContentLoaded", function () {
            var videoSource = "https://my.server.com/videoSource.m3u8";
            
            // 2-Adjust QUANTEEC configuration
            var configQuanteec = {
                quanteecKey: "{{ streamKey }}",
                videoID: "customVideoID" // [Optional but recommended] String --> specific name to identify a video. Useful if the videosource url contains a token which is different for every users. Default: the videoSource value is used.
            };
            
            var vjsObject = {
                
            }

            var player = videojs('videoplayer', vjsObject);

            // 3-Link QUANTEEC to videojs right *after* the creation of the player instance
            var quanteecPlayer = new Quanteec(configQuanteec, player);

            player.src([
                {
                    src: videoSource,
                    type: 'application/x-mpegurl'
                }
            ])     


            player.ready(function () {
                player.play();
            })
            
        });
    &lt;/script>
&lt;body>
```
    </vue-markdown>    
    


    <ConfigDoc class="col-xl-5 col-12">
    </ConfigDoc>
   
</b-row>
</b-col>
</b-row>
</b-container>

</template>
<script>
import ConfigDoc from '@/components/documentation/plugins/ConfigDoc.vue';
import VueMarkdown from 'vue-markdown';
import Prism from 'prismjs';
import 'prismjs/themes/prism-twilight.css';
export default {
  name: 'Videojs',
  data: function() {
    return {
     activePlugin:"noDRM",
    }
  },
  props: [
      "streamKey"
  ],
  components: {
      VueMarkdown,
      ConfigDoc
  },
  mounted: function() {

    this.$nextTick(() => {
        Prism.highlightAll()
      });  
  },
  methods: {
     onrender() {
        this.$nextTick(() => {
        Prism.highlightAll()
      });  
     }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.center {
    display: table;
    margin-left: auto;
    margin-right: auto;
    list-style-position: inside;
}

</style>